const TIME_SLOTS_MAP = {
  39: "7:00-7:45",
  40: "7:45-8:30",
  41: "8:30-9:15",
  42: "9:15-10:00",
  43: "10:00-10:45",
  44: "10:45-11:30",
  45: "11:30-12:15",
  46: "12:15-13:00",
  47: "13:00-13:45",
  48: "13:45-14:30",
  49: "14:30-15:15",
  50: "15:15-16:00",
  51: "16:00-16:45",
  52: "16:45-17:30",
  53: "17:30-18:15",
  54: "18:15-19:00",
  55: "19:00-19:45",
  56: "19:45-20:30",
  57: "20:30-21:15",
  58: "21:15-22:00",
};

export default TIME_SLOTS_MAP;
